import _ from 'lodash';

import {
  QueryCustomersFilterInput,
  useCustomersActivityLazyQuery
} from 'generated/graphql';

import { listQueryUtil } from 'iron-forge-react-modules';
import * as types from './types';



const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();



export interface ICustomer {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  recordUrl: string;
}

export interface IData {
  customers: ICustomer[];
}

export function useQuery() {
  return useListQuery({
    useLazyQuery: useCustomersActivityLazyQuery,
    clientColumn2GqlSortField: {
      email: 'email',
      firstName: 'firstName',
      lastName: 'lastName'
    },
    defaultFilterArgs: {},
    initQuerySort: {
      columnId: 'lastName',
      direction: 'ascending'
    },
    genFilter2GqlFilter: () => __filter2GqlFilter,
    gqlResultData2GqlPageInfo: gql => gql?.customers.pageInfo,
    gqlResultData2TupleData: (gql): IData => ({
      customers: _.map(gql.data?.customers.nodes ?? [], (node): ICustomer => ({
        id: node.id,
        email: node.email,
        lastName: node.lastName,
        firstName: node.firstName,
        phoneNumber: node.phoneNumber,
        recordUrl: node.netSuiteRecord?.recordUrl ?? ''
      }))
    })
  });
}



function __filter2GqlFilter(filter?: types.IFilter): QueryCustomersFilterInput {
  return {
    omniFreeText: filter?.searchText
  };
}
